(() => {
  if (window.AurevonaCartDrawerLinksInitialized) return;
  window.AurevonaCartDrawerLinksInitialized = true;

  const isCartRouteLink = (element) => {
    if (!element || !window.routes?.cart_url) return false;
    try {
      const linkPath = new URL(element.href, window.location.origin).pathname.replace(/\/$/, '');
      const cartPath = new URL(window.routes.cart_url, window.location.origin).pathname.replace(/\/$/, '');
      return linkPath === cartPath;
    } catch (error) {
      return false;
    }
  };

  document.addEventListener('click', (event) => {
    const explicitCartButton = event.target.closest('[data-aurevona-open-cart]');
    const linkedCartButton = event.target.closest('a[href]');
    const openCartButton = explicitCartButton || (isCartRouteLink(linkedCartButton) ? linkedCartButton : null);
    if (!openCartButton) return;

    event.preventDefault();
    const openDrawer = () => {
      const drawer = document.querySelector('cart-drawer.aurevona-cart');
      if (drawer && typeof drawer.open === 'function') drawer.open(openCartButton);
    };

    if (customElements.get('cart-drawer')) openDrawer();
    else customElements.whenDefined('cart-drawer').then(openDrawer);
  });
})();
